__turbopack_context__.v({
  "btnTooltip": "CircleButton-module-scss-module__biNxAW__btnTooltip",
  "btnTooltip__back": "CircleButton-module-scss-module__biNxAW__btnTooltip__back",
  "btnTooltip__copied": "CircleButton-module-scss-module__biNxAW__btnTooltip__copied",
  "circle__btn": "CircleButton-module-scss-module__biNxAW__circle__btn",
  "circle__btn__active": "CircleButton-module-scss-module__biNxAW__circle__btn__active",
  "circle__btn__link": "CircleButton-module-scss-module__biNxAW__circle__btn__link",
  "circle__btn__link__white": "CircleButton-module-scss-module__biNxAW__circle__btn__link__white",
  "circle__btn__white": "CircleButton-module-scss-module__biNxAW__circle__btn__white",
});
